@if (isRolloutMetricLayerVisible()) {
  <div class="position-absolute bottom-20 end-5 z-1">
    <app-legend>
      @if (isRolloutMetricLayerVisible()) {
        <app-legend-category name="Rollouts" [metric]="rolloutMetric()"></app-legend-category>
      }
    </app-legend>
  </div>
}
